import React from 'react';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';

import HomepageBanner from './src/components/HomepageBanner';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'custom-homepage-hero-banner',
        component: HomepageBanner,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
